<template>
  <div class="energy-label" :style="{ width: labelWidth }">
    <!-- pointy svg as background -->
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.53 45.9" class="energy-label-svg">
      <polygon points="20.93 0 0 22.95 20.93 45.9 82.53 45.9 82.53 0 20.93 0" :fill="getEnergyLabelColor" />
    </svg>
    <span class="energy-label-text">{{ getEnergyLabelText }}</span>
  </div>
</template>

<script>
  export default {
    name: 'EnergyLabel',
    props: {
      label: {
        type: String
      },
      labelWidth: {
        type: String,
        default: '55px'
      }
    },
    data() {
      return {
        energyLabelDefinitions: {
          'A++++': '#009037',
          'A+++': '#009037',
          'A++': '#009037',
          'A+': '#009037',
          'A': '#009037',
          'B': '#55ab27',
          'C': '#c8d102',
          'D': '#ffec02',
          'E': '#faba00',
          'F': '#eb6908',
          'G': '#e2001a'
        }
      }
    },
    computed: {
      getEnergyLabelText() {
        // uppercase and trim
        return this.label ? this.label.toUpperCase().trim() : '';
      },
      getEnergyLabelColor() {
        // remove non-alpha chars
        const energyLabelLetter = this.getEnergyLabelText.replace(/[^A-Z]/g, '');
        return this.energyLabelDefinitions[energyLabelLetter] || '#dedede';
      }
    }
  }
</script>

<style scoped>
  .energy-label {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
  }

  .energy-label-svg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .energy-label-text {
    position: relative;
    z-index: 1;
    margin-left: 28%;
  }
</style>